import { type Meta } from '../types/docs';

const META: Meta = {
  description: "Tracks captured text's bounding box edit",
  name: 'edited_captured_text_bounding_box',
  params: [
    {
      description: 'The ID of the captured text',
      name: 'text_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The captured text',
      name: 'text',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
